type Props = {
  height: string;
  stroke?: string;
  width: string;
};

const SizeGuideIcon = ({ height, width, stroke = 'black' }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4485_18641)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8888 3.40385C12.2794 3.01333 12.9125 3.01333 13.303 3.40385L15.4244 5.52517C15.8149 5.9157 15.8149 6.54886 15.4244 6.93939L6.93908 15.4247C6.54856 15.8152 5.91539 15.8152 5.52487 15.4247L3.40355 13.3033C3.01302 12.9128 3.01302 12.2797 3.40355 11.8891L11.8888 3.40385ZM11.2782 5.42867L12.5959 4.11096L14.7173 6.23228L6.23197 14.7176L4.11065 12.5962L5.42844 11.2785L6.31233 12.1623C6.40996 12.26 6.56825 12.26 6.66588 12.1623L6.7623 12.0659C6.85993 11.9683 6.85993 11.81 6.7623 11.7124L5.87842 10.8285L6.77845 9.92844L8.10428 11.2543C8.20191 11.3519 8.3602 11.3519 8.45783 11.2543L8.55426 11.1578C8.65189 11.0602 8.65189 10.9019 8.55426 10.8043L7.22843 9.47846L8.12838 8.57851L9.01227 9.46239C9.1099 9.56002 9.26819 9.56002 9.36582 9.46239L9.46224 9.36597C9.55988 9.26834 9.55988 9.11005 9.46224 9.01242L8.57836 8.12853L9.47832 7.22858L10.8041 8.5544C10.9018 8.65203 11.0601 8.65203 11.1577 8.5544L11.2541 8.45798C11.3517 8.36035 11.3517 8.20206 11.2541 8.10443L9.92829 6.7786L10.8282 5.87865L11.7121 6.76253C11.8098 6.86016 11.9681 6.86016 12.0657 6.76253L12.1621 6.66611C12.2597 6.56848 12.2597 6.41018 12.1621 6.31255L11.2782 5.42867Z"
          fill={stroke}
        />
        <path
          d="M0.928673 9.41426C0.733411 9.219 0.733411 8.90241 0.928673 8.70715C1.12394 8.51189 1.44052 8.51189 1.63578 8.70715L1.98933 9.06071L9.0604 1.98964L8.70685 1.63609C8.51159 1.44082 8.51159 1.12424 8.70685 0.928978C8.90211 0.733716 9.21869 0.733716 9.41395 0.928978L10.8282 2.34319C11.0234 2.53845 11.0234 2.85504 10.8282 3.0503C10.6329 3.24556 10.3163 3.24556 10.1211 3.0503L9.76751 2.69675L2.69644 9.76781L3.04999 10.1214C3.24526 10.3166 3.24526 10.6332 3.04999 10.8285C2.85473 11.0237 2.53815 11.0237 2.34289 10.8285L0.928673 9.41426Z"
          fill={stroke}
        />
      </g>
      <defs>
        <clipPath id="clip0_4485_18641">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SizeGuideIcon;
